module.exports = __webpack_public_path__ + "static/media/uk_Flag.7915e84b.jpeg";